export const getApolloErrorStatusCode = error => {
  var _error$networkError;
  return ((_error$networkError = error.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.status) || -1;
};